import React from "react";
import { templateDisplayName } from "./searchModes";

const plural = (count, one, many) => `${count} ${count === 1 ? one : many}`;
const count = (value) => (Number.isInteger(value) && value > 0 ? value : 0);

// An opening search that listed records but confirmed none, told kindly in the same voice as the follow-up card: what
// the search checked (the server's own counts and the records' own kinds), what the closest records do not confirm (their
// own reasons) and narrower searches made of the user's own words. It never says that something does not exist.
export default function SearchHelpCard({ help, templates, onSearch, disabled }) {
  if (!help || typeof help !== "object") return null;
  const listed = count(help.recordsListed);
  if (!listed) return null;
  const checked = Math.max(count(help.recordsChecked), listed);
  const kinds = (Array.isArray(help.kindsFound) ? help.kindsFound : [])
    .filter((kind) => kind && typeof kind.name === "string" && kind.name.trim())
    .slice(0, 2)
    .map((kind) => templateDisplayName(kind.name, templates));
  const notConfirmed = typeof help.notConfirmed === "string" ? help.notConfirmed.trim() : "";
  const suggestions = (Array.isArray(help.suggestedSearches) ? help.suggestedSearches : [])
    .filter((item) => item && typeof item.query === "string" && item.query.trim())
    .slice(0, 2);
  // The kinds are those of the listed records, not of every record checked, so they go with the listed count.
  const opening = (listed === 1 ? "Here is 1 related record" : `Here are ${listed} related records`) +
    (kinds.length ? ` from ${kinds.join(" and ")}` : "") + ".";
  const looked = `I checked ${plural(checked, "record", "records")}.`;
  return (
    <section className="chat-search-miss-card ds-search-help" aria-label="What the search checked">
      <p className="chat-search-miss-where">
        {opening} {looked}
        {notConfirmed ? ` ${listed === 1 ? "It doesn't" : "The closest ones don't"} confirm ${notConfirmed}.` : ""}
        {` You can open ${listed === 1 ? "it" : "them"} to check.`}
      </p>
      {suggestions.length > 0 && onSearch && (
        <div className="chat-search-miss-try">
          <p>To narrow it down, try a search with your words:</p>
          <div className="chat-search-miss-row">
            {suggestions.map((item) => (
              <button
                key={item.query}
                type="button"
                className="chat-search-ai-action"
                disabled={disabled}
                onClick={() => onSearch(item.query.trim())}
              >
                Search for: {item.query.trim()}
              </button>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
